import { Box, Stack } from "@mui/system";
import { useEffect, useMemo, useState } from "react";
import {
  Button,
  Card,
  CardContent,
  Container,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Divider,
  Grid,
  Paper,
  SvgIcon,
  TextField,
  Typography,
} from "@mui/material";
import CustomAppBar from "../../../components/CustomAppBar";
import { useLocation, useNavigate } from "react-router";
import RoundButton from "../../../components/RoundButton";
import EsignAgreementAlert from "../../../components/EsignAgreementAlert";
import moment from "moment-timezone";
import momentTimeZone from "moment";
import {
  MOMENT_CONSTANTS,
  convertUtcToYard,
  getTimeZone,
} from "../../../utils/momentUtils";
import CancelReservationSpecifyReasonModal from "../../../components/reservation/Modals/CancelReservationSpecifyReasonModal";
import MenuBar from "../../menuBar";
import { useResponsive } from "../../../hooks/useResponsive";

import { ReactComponent as LocationIcon } from "./../../../assets/svg/locationIcon.svg";
import { ReactComponent as ReservationDateIcon } from "./../../../assets/svg/res_dateIcon.svg";

import { ReactComponent as MonthlyRecurIcon } from "./../../../assets/svg/monthlyIcon.svg";
import { ReactComponent as AllocatedSpotsIcon } from "./../../../assets/svg/allocatedSpotsIcon.svg";
import { useDispatch, useSelector } from "react-redux";
import {
  getLocationSolrListApi,
  doOpenGate,
  cancelReservationRequest,
  scheduleMoveOutRequest,
} from "../../../redux/reservations/action";
import { fetchPaymentHistory } from "../../../redux/payments/action";
import { getPaymentType } from "../../payments/makePayment/utils";
import { makeStyles } from "@mui/styles";
import {
  isAppInLatestVersion,
  isMobileDeviceCheck,
  truncateLocationName,
} from "../../../utils";
import { sendMessageToReactNative } from "../../../utils";
import CustomAlert from "../../../components/CustomAlert";
import storePersist, { localConstant } from "../../../services/localStorage";
import { enqueueSnackbar } from "notistack";
import { useTranslation } from "react-i18next";
import ExitIcon from "../../../assets/Icon/ExitIcon";
import EnterIcon from "../../../assets/Icon/EnterIcon";
import { getSpotTitle } from "../../../utils/utils";
import Alert from "../../../components/Alert";
import { fetchCustomerEsignStatus } from "../../../services/apiManager/apiRequests";

const useStyles = makeStyles((theme) => ({
  paper: {
    height: 50,
    padding: theme.spacing(2),
    display: "flex",
    alignItems: "center",
    boxShadow: "none !important",
    border: "1px solid lightgrey",
    borderRadius: "2px",
  },
  circle: {
    borderRadius: "50%",
    width: 40,
    height: 40,
    backgroundColor: "#DADADA",
    color: "black",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    marginRight: theme.spacing(1),
  },
  rightContent: {
    marginLeft: "auto",
    textAlign: "right",
  },
}));
const Text = ({ content, color }) => (
  <Typography variant="body2" color={color} textTransform="uppercase">
    {content}
  </Typography>
);

export const ReservationStatus = ({ statusCode }) => {
  const { t } = useTranslation();

  switch (statusCode) {
    case "PNDG_CONF":
      return <Text content={t("pages.reservation.text06")} color="orange" />;

    case "CONFIRMED":
      return <Text content={t("pages.reservation.text07")} color="green" />;

    case "CHCKD_OUT":
      return <Text content={t("pages.reservation.text08")} color="green" />;

    case "PNDG_COUT":
      return <Text content={t("pages.reservation.text09")} color="orange" />;

    case "PNDG_EXT":
      return <Text content={t("pages.reservation.text10")} color="orange" />;

    default:
      return <Text content={statusCode} color="red" />;
  }
};

const OutGateButtonStyles = {
  margin: "2px 3px",
  width: "48%",
  color: "#1D5AB9",
  backgroundColor: "white",
  boxShadow: "none",
  height: "35px",
  border: "1px solid lightgrey",
};

const InGateButtonColor = "primary";

const InGateTextColor = "primary.main";

const ReservationDetailsPage = () => {
  const { locationData, selectedReservation, selectedGates } = useSelector(
    (state) => state.reservationReducer,
  );

  const [popupDialogProps, setPopupDialogProps] = useState({
    isOpen: false,
    gate: "",
    reset: () =>
      setPopupDialogProps((prev) => ({
        ...prev,
        isOpen: false,
        gate: "",
      })),
  });

  const openGateForUser = (gateId) => {
    setGateId(gateId);
    sendMessageToReactNative("GET_DEVICE_LOCATION");
  };

  const userType = storePersist.get(localConstant.USER_PROFILE);

  const appVersion = storePersist.get(localConstant.APP_VERSION);
  const { paymentHistory } = useSelector((state) => state.paymentsReducer);
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();
  const spotData = location?.state?.spotData;

  const lgUp = useResponsive("up", "lg");
  const [totalSpotCount, setSpotCount] = useState(0);

  const spotTypes = useMemo(() => {
    const allSpots = spotData?.spotAllocation[0]?.spots;
    let spotCount = 0;
    if (!allSpots) {
      return [];
    }
    const currentTime = momentTimeZone().utc().toISOString();
    const constructRecord = allSpots.map((item) => {
      const spotNums = item.spotNums.map((val) => {
        const isExpired =
          val.endDate &&
          val.endDate < currentTime &&
          val.endDate != spotData?.toDate;
        return isExpired ? `<s>${val.spotNum}</s>` : val.spotNum;
      });

      spotCount += spotNums.length;
      return {
        spotType: item.spotType,
        spotNums,
      };
    });
    setSpotCount(spotCount);
    return constructRecord;
  }, [spotData?.spotAllocation]);

  const [gateId, setGateId] = useState();
  const classes = useStyles();
  const { t } = useTranslation();

  const timeZone = locationData?.[0]?.timezone;
  const isMonthly = spotData?.reservationType === "MONTHLY";

  const fromDate = convertUtcToYard({
    date: spotData?.fromDate,
    timeZone: timeZone,
  });
  const toDate = spotData?.toDate
    ? convertUtcToYard({ date: spotData?.toDate, timeZone: timeZone })
    : moment.utc(spotData?.fromDate).endOf("month").tz(timeZone);

  const formattedfromDate = fromDate?.format(
    isMonthly
      ? MOMENT_CONSTANTS.date.fullMonthDay
      : MOMENT_CONSTANTS.dateWithTime.monthDay12Hours,
  );

  const formattedtoDate = toDate?.format(
    isMonthly
      ? MOMENT_CONSTANTS.date.fullMonthDay
      : MOMENT_CONSTANTS.dateWithTime.monthDay12Hours,
  );

  const displayFromDateToDate = isMonthly
    ? spotData?.toDate
      ? `${formattedfromDate} to ${formattedtoDate} ${getTimeZone(timeZone)}`
      : `${formattedfromDate} ${getTimeZone(timeZone)}`
    : `${formattedfromDate} to ${formattedtoDate} ${getTimeZone(timeZone)}`;

  const reservationType =
    spotData?.reservationType === "MONTHLY"
      ? t("pages.makeReservation.actionItem02")
      : t("pages.makeReservation.actionItem01");

  const buttonText =
    spotData?.reservationType === "MONTHLY"
      ? t("pages.reservationDetails.text14")
      : t("pages.reservationDetails.text09");

  const cancelApi =
    spotData?.reservationType === "MONTHLY"
      ? scheduleMoveOutRequest
      : cancelReservationRequest;

  const isExtend = spotData?.reservationType === "MONTHLY" ? false : true;

  const userTypeOperator =
    storePersist.get(localConstant.USER_PROFILE) !== "OWNER";

  const disableContinue =
    toDate?.isBefore(moment(new Date())) || userTypeOperator;
  const disableCancel =
    spotData?.reservationStatus === "CONFIRMED" ||
    spotData?.reservationStatus === "PNDG_EXT" ||
    spotData?.reservationStatus === "PNDG_CONF";
  const disableExtend = isExtend && spotData?.reservationStatus === "PNDG_CONF";

  const disableAllActions = spotData?.reservationStatus === "CHCKD_OUT";

  const disableScheduleMoveOut = spotData?.reservationStatus === "PNDG_CONF";
  const address = `${locationData?.[0]?.location_address_line_1}, ${locationData?.[0]?.location_city}`;

  const [isopenGate, setOpenGate] = useState(false);

  useEffect(() => {
    dispatch(
      fetchPaymentHistory(
        {
          customerId: spotData?.customerId,
          reservationId: spotData?.reservationId,
        },
        (response) => {},
      ),
    );
  }, []);

  useEffect(() => {
    if (spotData?.spotAllocation?.length > 0) {
      const params = {
        "q.op": "OR",
        start: "0",
        rows: "10000",
        wt: "json",
        cl: "OPS",
        fq: `location_id:${spotData?.spotAllocation[0].locationId}`,
      };

      dispatch(getLocationSolrListApi(params, (response) => {}));
    }
  }, [spotData]);

  useEffect(() => {
    if (spotData?.spotAllocation?.length > 0) {
      if (spotData?.isReserve) {
      }
    }
  }, [spotData]);

  const [openDialogConfirmation, setOpenDialogConfirmation] = useState(false);

  const handleClickOpenDialogConfirmation = () => {
    setOpenDialogConfirmation(true);
  };

  const handleCloseDialogConfirmation = () => {
    setOpenDialogConfirmation(false);
  };

  const [openDialogScheduleMoveOut, setOpenDialogScheduleMoveOut] =
    useState(false);

  const handleClickOpenDialogScheduleMoveOut = () => {
    setOpenDialogScheduleMoveOut(true);
  };

  const handleCloseDialogScheduleMoveOut = () => {
    setOpenDialogScheduleMoveOut(false);
  };

  const [reasonMoveOut, setReasonMoveOut] = useState("");

  const handleReasonMoveOut = (e) => setReasonMoveOut(e.target.value);

  const [openDialogMoveOutProps, setOpenDialogMoveOutProps] = useState({});

  const handleClickOpenDialogMoveOut = (data) => {
    setOpenDialogMoveOutProps(data);
  };

  const getAlertProps = (response) => {
    const isSuccess = response.success;
    const isReservation = isExtend ? "Reservation" : "Move Out";

    let title, variant, content, subTitle;

    if (isSuccess) {
      title = isExtend
        ? `${t("pages.reservationDetails.text17")}`
        : `${t("pages.reservationDetails.text18")}`;
      subTitle = `${t("pages.reservationDetails.text19")} - ${
        spotData?.reservationId
      }`;
      variant = "success";
      content = isExtend
        ? `${t("pages.reservationDetails.text19")} ${
            spotData?.reservationId
          } ${t("pages.reservationDetails.text20")}`
        : `${t(
            "pages.reservationDetails.text21",
          )} ${isReservation.toLowerCase()} ${t(
            "pages.reservationDetails.text22",
          )} ${moment()?.format(MOMENT_CONSTANTS.date.fullMonthDay)}`;
    } else {
      title = isExtend
        ? `${t("pages.reservationDetails.text23")}`
        : `${t("pages.reservationDetails.text24")}`;
      subTitle = `${t("pages.reservationDetails.text19")} - ${
        spotData?.reservationId
      }`;
      variant = "error";
      content = response.error || "Unknown Error";
    }

    return { title, variant, content, subTitle };
  };

  const dialogConfirmation = (
    <>
      <Dialog
        open={openDialogConfirmation}
        onClose={handleCloseDialogConfirmation}
        aria-labelledby="responsive-dialog-title"
        fullWidth={true}
      >
        <DialogTitle id="responsive-dialog-title">
          {isExtend
            ? `${t("pages.cancelReservation.pageHeading")}`
            : `${t("pages.reservationDetails.text14")}`}
        </DialogTitle>
        <DialogContent>
          <DialogContentText>
            {isExtend
              ? `${t("pages.cancelReservation.pageHeading")}`
              : `${t("pages.cancelReservation.text01")}`}{" "}
            (id - {spotData?.reservationId}) ?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button
            autoFocus
            onClick={handleCloseDialogConfirmation}
            style={{
              width: "25%",
              background: "white",
              border: "1px solid grey",
              color: "grey",
              height: "40px",
            }}
          >
            {t("commonLabels.text22")}
          </Button>
          <Button
            onClick={() => {
              handleCloseDialogConfirmation();
              !isExtend
                ? handleClickOpenDialogScheduleMoveOut()
                : dispatch(
                    cancelApi(
                      { reservationId: spotData?.reservationId },
                      {},
                      (response) =>
                        handleClickOpenDialogMoveOut({
                          isOpen: true,
                          ...getAlertProps(response),
                        }),
                    ),
                  );
            }}
            style={{
              width: "25%",
              height: "40px",
            }}
            autoFocus
          >
            {t("commonLabels.text21")}
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );

  const dialogScheduleMoveOut = (
    <>
      <Dialog
        open={openDialogScheduleMoveOut}
        onClose={handleCloseDialogScheduleMoveOut}
        aria-labelledby="responsive-dialog-title"
        fullWidth={true}
      >
        <DialogTitle id="responsive-dialog-title">
          {t("components.cancelReservationSpecifyReasonModal.text01")}
          <span style={{ color: "#C50F1F" }}>*</span>
        </DialogTitle>
        <DialogContent>
          <DialogContentText>
            {!isExtend
              ? t("components.cancelReservationSpecifyReasonModal.text03")
              : t("components.cancelReservationSpecifyReasonModal.text02")}
          </DialogContentText>
          <TextField
            id="outlined-multiline-static"
            label=""
            multiline
            rows={4}
            placeholder="Not travelling"
            style={{
              width: "100%",
              marginTop: "5%",
            }}
            value={reasonMoveOut}
            onChange={handleReasonMoveOut}
          />
        </DialogContent>
        <DialogActions
          style={{
            justifyContent: "center",
          }}
        >
          <Button
            onClick={() => {
              if (reasonMoveOut?.length > 0) {
                handleCloseDialogScheduleMoveOut();
                dispatch(
                  cancelApi(
                    { reservationId: spotData?.reservationId },
                    null,
                    (response) =>
                      handleClickOpenDialogMoveOut({
                        isOpen: true,
                        ...getAlertProps(response),
                      }),
                  ),
                );
              }
            }}
            autoFocus
            style={{
              width: "45%",
              height: "40px",
            }}
          >
            {t("commonLabels.text23")}
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );

  const dialogMoveOut = (
    <>
      <CustomAlert
        onClick={() => navigate("/ownerDashboard")}
        {...openDialogMoveOutProps}
      />
    </>
  );
  const doGateAccess = (gateId, userLat, userLng) => {
    if (gateId) {
      dispatch(
        doOpenGate(
          {
            lat: userLat,
            lng: userLng,
            gateId: gateId,
            reservationId: selectedReservation?.reservation_id,
          },
          (response) => {
            console.log("doOpenGate Response:", response);
          },
        ),
      );
    } else {
      enqueueSnackbar(t("pages.reservationDetails.text25"), {
        variant: "error",
      });
    }
  };
  const onMessageFromRN = (message) => {
    try {
      const { action, payload } = JSON.parse(message);

      if (action === "User_Location") {
        //we can use payload data over here to pass data to api call
        doGateAccess(
          gateId,
          payload?.coords?.latitude,
          payload?.coords?.longitude,
        );
      }
    } catch (error) {
      console.error("Error parsing message:", error);
    }
  };

  const formatDateTime = (date) => {
    return moment(date).format("MM/DD/YYYY");
  };

  // Attach the handler to `window` so we can access it from
  // scripts injected by React Native WebView.
  window.onMessageFromRN = onMessageFromRN;

  const customerEsignStatus = async () => {
    if (
      storePersist.get(localConstant.AGREEMENT_STATUS) === "COMPLTD" ||
      storePersist.get(localConstant.AGREEMENT_STATUS) === "COMPLETED"
    ) {
      return true;
    } else {
      const esignStatus = await fetchCustomerEsignStatus();
      if (
        esignStatus?.agrmntStatusCd === "COMPLETED" ||
        esignStatus?.agrmntStatusCd === "COMPLTD"
      ) {
        storePersist.set(
          localConstant.AGREEMENT_STATUS,
          esignStatus?.agrmntStatusCd,
        );
        storePersist.set(localConstant.AGREEMENT_ID, esignStatus?.agrmntId);
        return true;
      }
      storePersist.set(localConstant.AGREEMENT_ID, esignStatus?.agrmntId);
      return false;
    }
  };

  const displayEsginRequestMessage = (equipment_id) => {
    setPopupDialogProps((prev) => ({
      ...prev,
      isOpen: true,
      gate: { equipment_id },
    }));
  };

  return (
    <div
      style={{
        width: lgUp ? `calc(100% - ${240}px)` : "100%",
        marginLeft: lgUp ? "240px" : 0,
      }}
    >
      <CustomAppBar
        title={t("pages.reservationDetails.pageHeading")}
        showBackButton={true}
        onBackButtonClick={() => {
          if (
            location?.state?.from === "/reservation" &&
            spotData?.reservationStatus === "CANCELLED"
          ) {
            navigate("/reservation", {
              state: {
                tabType: "Past",
              },
            });
          } else if (
            location?.state?.from === "/reservation" &&
            spotData?.reservationStatus === "CONFIRMED"
          ) {
            navigate("/reservation", {
              state: {
                tabType: "Active",
              },
            });
          } else {
            navigate(-1);
          }
        }}
      />
      <MenuBar />
      <Container
        style={{
          position: "relative",
          width: "100%",
          height: "100%",
          minHeight: "90vh",
        }}
      >
        <div
          style={{
            overflowY: "auto",
          }}
        >
          <Grid container direction={"column"} sx={{ mt: 2 }}>
            <Typography variant="h5" color={"primary.secondary"}>
              {/* Safe Truck Parking - Orlando */}
              {locationData?.length > 0 &&
                truncateLocationName(locationData[0].location_display_name)}
            </Typography>
            <Typography variant="body2" color={"primary.secondary"}>
              {/* 7501 Zell Dr, Orlando, FL, 67543 */}
              {locationData?.length > 0 &&
                locationData[0].location_address_line_1}
            </Typography>

            <Typography
              variant="body2"
              color={"primary.secondary"}
              style={{ fontWeight: "bold" }}
            >
              {t("pages.reservationDetails.text19")} - {spotData?.reservationId}
            </Typography>
          </Grid>
          <Stack sx={{ mt: 2 }} spacing={2}>
            <Divider width={"100%"} />
          </Stack>
          <Stack sx={{ mt: 2 }} spacing={2}>
            <Grid container direction={"row"} sx={{ mt: 2 }}>
              <SvgIcon
                component={LocationIcon}
                inheritViewBox
                sx={{ width: "20px", height: "20px", mr: 1 }}
              />
              <Typography
                sx={{ textDecoration: "underline", cursor: "pointer" }}
                color="blue"
                onClick={() => {
                  isMobileDeviceCheck() && isAppInLatestVersion(appVersion)
                    ? sendMessageToReactNative(`OPEN_NATIVE_MAP:${address}`)
                    : window.open(
                        `https://www.google.com/maps/search/${address}`,
                        "_blank",
                      );
                }}
              >
                <Typography variant="body2" color={"primary.secondary"}>
                  {/* 7501 Zell Dr, Orlando, FL, 67543 */}
                  {address}
                </Typography>
              </Typography>
            </Grid>
            <Grid container direction={"row"} sx={{ mt: 2 }}>
              <SvgIcon
                component={ReservationDateIcon}
                inheritViewBox
                sx={{ width: "20px", height: "20px", mr: 1 }}
              />
              <Typography variant="body2" color={"primary.secondary"}>
                {displayFromDateToDate}
              </Typography>
            </Grid>
            <Grid container direction={"row"} sx={{ mt: 2 }}>
              <SvgIcon
                component={MonthlyRecurIcon}
                inheritViewBox
                sx={{ width: "20px", height: "20px", mr: 1 }}
              />
              <Typography variant="body2" color={"primary.secondary"}>
                {reservationType}
              </Typography>
            </Grid>
            <Grid container direction={"row"} sx={{ mt: 2 }}>
              <SvgIcon
                component={AllocatedSpotsIcon}
                inheritViewBox
                sx={{ width: "20px", height: "20px", mr: 1 }}
              />
              <Typography
                variant="body2"
                color={"primary.secondary"}
                sx={{ mr: 1 }}
              >
                {`${totalSpotCount}  Spot${totalSpotCount > 1 ? "s" : ""} ${t(
                  "pages.reservationDetails.text27",
                )},`}
              </Typography>
              <ReservationStatus statusCode={spotData?.reservationStatus} />
            </Grid>

            <Grid container direction={"row"} sx={{ mt: 2 }}>
              <Typography variant="fontBoldSize16" color={"primary.secondary"}>
                {t("pages.reservationDetails.text03")}
              </Typography>
            </Grid>

            {spotTypes.map((item, index) => {
              return (
                item.spotNums.length > 0 && (
                  <Grid
                    container
                    direction="row"
                    sx={{ mt: 2 }}
                    gap=".2rem"
                    key={index}
                  >
                    <Typography variant="fontSize16" color="black">
                      {`${getSpotTitle(item.spotType)}`} -{" "}
                    </Typography>
                    <Typography fontWeight="bold">
                      {item.spotNums?.map((spotNum, i) => (
                        <span
                          key={i}
                          style={{
                            color:
                              typeof spotNum === "string" &&
                              spotNum.startsWith("<s>")
                                ? "red"
                                : "black",
                          }}
                        >
                          {typeof spotNum === "string" &&
                          spotNum.startsWith("<s>") ? (
                            <span
                              dangerouslySetInnerHTML={{ __html: spotNum }}
                            />
                          ) : (
                            spotNum
                          )}
                          {i < item.spotNums.length - 1 ? ", " : ""}
                        </span>
                      ))}
                    </Typography>
                  </Grid>
                )
              );
            })}

            {isMobileDeviceCheck() &&
              !disableAllActions &&
              (spotData?.reservationStatus === "CONFIRMED" ||
                spotData?.reservationStatus === "PNDG_EXT") && (
                <Grid container direction={"row"} sx={{ mt: 2 }}>
                  <Typography
                    variant="fontBoldSize16"
                    color={"primary.secondary"}
                  >
                    {t("pages.reservationDetails.text04")}
                  </Typography>
                </Grid>
              )}
            {isMobileDeviceCheck() &&
              !disableAllActions &&
              (spotData?.reservationStatus === "CONFIRMED" ||
                spotData?.reservationStatus === "PNDG_EXT") && (
                <div>
                  {selectedGates &&
                    selectedGates.map((d, i) => {
                      return (
                        <Stack direction="row" spacing={0} key={i}>
                          {i % 2 === 0 && selectedGates[i]?.equipment_id && (
                            <Button
                              type="submit"
                              variant="contained"
                              color={
                                selectedGates?.[i]?.equipment_direction === "IN"
                                  ? InGateButtonColor
                                  : InGateButtonColor
                              }
                              style={
                                selectedGates?.[i]?.equipment_direction === "IN"
                                  ? OutGateButtonStyles
                                  : OutGateButtonStyles
                              }
                              endIcon={
                                selectedGates?.[i]?.equipment_direction ===
                                "IN" ? (
                                  <EnterIcon
                                    color="#1D5AB9"
                                    width="28px"
                                    height="28px"
                                  />
                                ) : (
                                  <ExitIcon
                                    color="#1D5AB9"
                                    width="28px"
                                    height="28px"
                                  />
                                )
                              }
                              onClick={async () => {
                                const isEsignComplete =
                                  await customerEsignStatus();
                                if (!isEsignComplete) {
                                  displayEsginRequestMessage(
                                    selectedGates[i]?.equipment_id,
                                  );
                                } else {
                                  openGateForUser(
                                    selectedGates[i]?.equipment_id,
                                  );
                                }
                              }}
                            >
                              <Typography
                                variant="subtitle2"
                                color={
                                  selectedGates?.[i]?.equipment_direction ===
                                  "IN"
                                    ? InGateTextColor
                                    : InGateTextColor
                                }
                                sx={{
                                  whiteSpace: "nowrap",
                                  display: "inline-block",
                                }}
                              >
                                {selectedGates?.[i]?.equipment_name}
                              </Typography>
                            </Button>
                          )}
                          {i % 2 === 0 &&
                            selectedGates[i + 1]?.equipment_id && (
                              <Button
                                type="submit"
                                variant="contained"
                                color={
                                  selectedGates?.[i + 1]
                                    ?.equipment_direction === "IN"
                                    ? InGateButtonColor
                                    : InGateButtonColor
                                }
                                style={
                                  selectedGates?.[i + 1]
                                    ?.equipment_direction === "IN"
                                    ? OutGateButtonStyles
                                    : OutGateButtonStyles
                                }
                                endIcon={
                                  selectedGates?.[i + 1]
                                    ?.equipment_direction === "IN" ? (
                                    <EnterIcon
                                      color="#1D5AB9"
                                      width="28px"
                                      height="28px"
                                    />
                                  ) : (
                                    <ExitIcon
                                      color="#1D5AB9"
                                      width="28px"
                                      height="28px"
                                    />
                                  )
                                }
                                onClick={async () => {
                                  const isEsignComplete =
                                    await customerEsignStatus();
                                  if (!isEsignComplete) {
                                    displayEsginRequestMessage(
                                      selectedGates[i + 1]?.equipment_id,
                                    );
                                  } else {
                                    openGateForUser(
                                      selectedGates[i + 1]?.equipment_id,
                                    );
                                  }
                                }}
                              >
                                <Typography
                                  variant="subtitle2"
                                  color={
                                    selectedGates?.[i + 1]
                                      ?.equipment_direction === "IN"
                                      ? InGateTextColor
                                      : InGateTextColor
                                  }
                                  sx={{
                                    whiteSpace: "nowrap",
                                    display: "inline-block",
                                  }}
                                >
                                  {selectedGates?.[i + 1]?.equipment_name}
                                </Typography>
                              </Button>
                            )}
                        </Stack>
                      );
                    })}
                </div>
              )}
          </Stack>
          {spotData?.billing?.[0]?.dueAmount > 0 &&
          !disableAllActions &&
          userType === "OWNER" ? (
            <Box sx={{ mb: paymentHistory?.length > 0 ? 0 : 15 }}>
              <p
                style={{
                  fontWeight: "bolder",
                }}
              >
                {t("pages.reservationDetails.text28")}
              </p>

              <Card
                style={{
                  boxShadow: "none",
                  border: "1px solid lightgrey",
                  borderRadius: "2px",
                }}
              >
                <CardContent>
                  <Grid
                    item
                    container
                    direction={"row"}
                    spacing={0}
                    sx={{ height: "20px" }}
                    justifyContent={"space-between"}
                  >
                    <Grid item>
                      <Typography
                        variant="gateTitle"
                        color={"#656363"}
                        style={{
                          fontSize: "100%",
                        }}
                      >
                        {t("pages.reservationDetails.text29")} - $
                        {spotData?.billing?.[0]?.dueAmount?.toFixed(2)}
                      </Typography>
                    </Grid>
                    <Grid item>
                      {!userTypeOperator && (
                        <Button
                          type="submit"
                          variant="contained"
                          alignSelf={"center"}
                          style={{
                            alignSelf: "center",
                            width: 100,
                            height: 32,
                            alignItems: "center",
                            margin: "auto",
                            display: "flex",
                            borderRadius: "5px",
                            backgroundColor: "#d1def1",
                            boxShadow: "none",
                          }}
                          className="update_button"
                          onClick={() => {
                            navigate("/makePayment", {
                              state: {
                                ...spotData,
                                hideCancel: true,
                                billing: {
                                  charges: [
                                    {
                                      totalAmount:
                                        spotData?.billing?.[0]?.dueAmount,
                                      billNums:
                                        spotData?.billing?.[0]?.dueBillNums,
                                    },
                                  ],
                                },
                                reservationId: spotData?.reservationId,
                              },
                            });
                          }}
                        >
                          <Typography variant="buttonText" color="black">
                            {t("pages.reservationDetails.text30")}
                          </Typography>
                        </Button>
                      )}
                    </Grid>
                  </Grid>
                </CardContent>
              </Card>
            </Box>
          ) : null}
          {paymentHistory?.length > 0 && userType === "OWNER" ? (
            <Box sx={{ mb: 15 }}>
              <p
                style={{
                  fontWeight: "bolder",
                }}
              >
                {t("pages.reservationDetails.text31")}
              </p>
              <Grid container spacing={0}>
                {paymentHistory?.map((data, index) => (
                  <Grid item xs={12} key={index}>
                    <Paper
                      className={classes.paper}
                      sx={{ height: "max-content !important" }}
                    >
                      <div className={classes.circle}>{index + 1}</div>
                      <div>
                        <Typography variant="subtitle1">
                          {t("pages.reservationDetails.text32")} -{" "}
                          {data.transaction_reference_number || "NA"}
                        </Typography>
                        <Typography
                          variant="body1"
                          style={{
                            color: "grey",
                          }}
                        >
                          {t("pages.reservationDetails.text33")} -{" "}
                          {getPaymentType(data?.payment_mode_code)}
                        </Typography>
                        <Typography
                          variant="body1"
                          style={{
                            color: "green",
                          }}
                        >
                          {t("pages.reservationDetails.text37")} -{" "}
                          {formatDateTime(data?.payment_date)}
                        </Typography>
                      </div>
                      <div className={classes.rightContent}>
                        <Typography variant="h6">
                          ${data?.payment_amount}
                        </Typography>
                        <Typography
                          variant="body2"
                          style={{
                            color: "green",
                          }}
                        >
                          {data.payment_type_code === "PAYIN"
                            ? t("pages.reservationDetails.text34")
                            : t("pages.reservationDetails.text35")}
                        </Typography>
                      </div>
                    </Paper>
                  </Grid>
                ))}
              </Grid>
            </Box>
          ) : null}
        </div>
        <Stack
          sx={{
            margin: "auto",
            mt: 2,
            mb: 2,
            left: 0,
            right: 0,
            position: "absolute",
            bottom: 0,
            width: "90%",
            maxWidth: 900,
          }}
          spacing={2}
        >
          <Stack direction={"row"} spacing={1}>
            {!disableContinue && !disableCancel && !disableAllActions && (
              <RoundButton
                sx={{
                  backgroundColor: "#fff",
                  borderColor: "#8A8886",
                  color: "#605E5C",
                  ":hover": { backgroundColor: "transparent" },
                }}
                size="large"
                fullWidth
                variant="contained"
                type="submit"
                color="primary"
                rounded
                onClick={() => {
                  handleClickOpenDialogConfirmation();
                }}
              >
                <Typography variant="buttonText">
                  {t("commonLabels.text02")}
                </Typography>
              </RoundButton>
            )}
            {!disableContinue &&
              !disableExtend &&
              !disableAllActions &&
              !disableScheduleMoveOut && (
                <RoundButton
                  size="large"
                  fullWidth
                  variant="contained"
                  type="submit"
                  color="primary"
                  disabled={
                    spotData?.reservationType === "MONTHLY" && spotData?.toDate
                      ? true
                      : false
                  }
                  rounded
                  onClick={() => {
                    if (isExtend) {
                      navigate("/extendReservation", {
                        state: {
                          ...spotData,
                          timeZone: timeZone,
                        },
                      });
                    } else {
                      handleClickOpenDialogConfirmation();
                    }
                  }}
                >
                  <Typography variant="buttonText" color="common.buttonText">
                    {buttonText}
                  </Typography>
                </RoundButton>
              )}
          </Stack>
        </Stack>
        {popupDialogProps.isOpen && (
          <EsignAgreementAlert
            {...popupDialogProps}
            handleGateOpen={(item, gate) => openGateForUser(gate?.equipment_id)}
            displayEsignSignNow={
              storePersist.get(localConstant.USER_PROFILE) === "OWNER"
            }
          />
        )}

        <CancelReservationSpecifyReasonModal
          isOpen={isopenGate}
          onSubmit={() => {
            setOpenGate(false);
          }}
        />

        {dialogConfirmation}
        {dialogScheduleMoveOut}
        {dialogMoveOut}
      </Container>
    </div>
  );
};

export default ReservationDetailsPage;
